import axios from 'axios';
import Vue from 'vue'

export default {
    saveAnnouncment(announcment){
        return axios.post('/api/exchange/save',announcment)
        .then(response => {
            
            if (response && response.data) {
                Vue.prototype.$snotify.success("Annonce enregistrée avec succès");
                return response.data;
            } 
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})

    },
    
    deleteAnnouncment(announcment){
        return axios.post('/api/exchange/delete',announcment)
        .then(response => {
            
            if (response && response.data) {
                Vue.prototype.$snotify.success("Annonce supprimée avec succès");
                return response.data;
            } 
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})

    },

    getMyAnnoucments (page, pageSize) {
        return axios.get('/api/exchange/list', { params: {page: page, pageSize: pageSize} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getOthersAnnoucments (page, pageSize,productTitleFilter,expirationDateFiler,cityFilter,sliderPriceFilter) {
        return axios.get('/api/exchange/all/list', { params: {page: page, pageSize: pageSize, productTitleFilter:productTitleFilter,expirationDateFiler:expirationDateFiler,cityFilter:cityFilter,sliderPriceFilter:sliderPriceFilter} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getMaxPrice () {
        return axios.get('/api/exchange/maxPrice')
        .then(response => {
            if (response && (response.data|| response.data==0)) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

}